module.exports = __webpack_public_path__ + "static/media/instructor-7.10cd2219.png";